// chatbot-widget
// The Kodif widget is loaded on all pages by its theme app embed (see config/settings_data.json).
// The embed creates the #kodif-chat-widget iframe with an inline `z-index: 2147483647 !important`
// (the browser max), which no stylesheet rule can override. Rivo's .rivo-slideout__overlay uses
// z-index 999999999999, which browsers clamp to that same max, so the tie is broken by DOM order
// and the (transparent) widget iframe sits on top of the slideout, invisibly blocking it.
// Capping the widget one step below the max keeps it above everything else, in both its
// collapsed and expanded states, while letting the Rivo slideout render above it.

const KODIF_MAX_Z_INDEX = 2147483647
const KODIF_CAPPED_Z_INDEX = KODIF_MAX_Z_INDEX - 1

function capKodifZIndex(iframe) {
  const zIndex = parseInt(window.getComputedStyle(iframe).zIndex, 10)
  // Only lower values above the cap so intentional drops are left alone
  // (e.g. cart-drawer.js sets it to 4 when the cart drawer opens)
  if (isNaN(zIndex) || zIndex > KODIF_CAPPED_Z_INDEX)
    iframe.style.setProperty('z-index', KODIF_CAPPED_Z_INDEX, 'important')
}

function watchKodifZIndex(iframe) {
  capKodifZIndex(iframe)
  // Re-cap if the Kodif script raises the inline z-index again
  // (it re-sets it from postMessage state updates)
  const styleObserver = new MutationObserver(function () {
    capKodifZIndex(iframe)
  })
  styleObserver.observe(iframe, { attributes: true, attributeFilter: ['style'] })
}

function initKodifZIndexCap() {
  const iframe = document.getElementById('kodif-chat-widget')
  if (iframe) {
    watchKodifZIndex(iframe)
    return
  }
  // The app embed injects the iframe asynchronously, so wait for it to appear
  const bodyObserver = new MutationObserver(function () {
    const injectedIframe = document.getElementById('kodif-chat-widget')
    if (!injectedIframe) return
    bodyObserver.disconnect()
    watchKodifZIndex(injectedIframe)
  })
  bodyObserver.observe(document.body, { childList: true, subtree: true })
}

initKodifZIndexCap()
